import React from 'react';
import ReactDOM from 'react-dom/client';

import TagManager from 'react-gtm-module';

import Main from './main';

const root = ReactDOM.createRoot(document.getElementById('root'));

const env = process.env.NODE_ENV;

const tagManagerArgs = {
	gtmId: "GTM-KQ7DN5RM"
};

if(env === "production") {
	TagManager.initialize(tagManagerArgs);
}

root.render(
	<Main />
)
